import styles from './index.less';
import React from 'react';
import { GAME_WEBSITE_ENTRY, GAME_DOWNLOAD_PAGE } from '@src/constants/urls';

const websiteImage = require('./images/website.png');
const downloadImage = require('./images/download.png');

const HeaderActions = ({ onWebsiteClick, onDownloadClick }) => (
  <nav className={styles.root} aria-label="官网与下载">
    <a href={GAME_WEBSITE_ENTRY} aria-label="进入官网" onClick={onWebsiteClick} target="_blank" rel="noopener noreferrer">
      <img src={websiteImage} alt="" />
    </a>
    <a href={GAME_DOWNLOAD_PAGE} aria-label="下载游戏" onClick={onDownloadClick} target="_blank" rel="noopener noreferrer">
      <img src={downloadImage} alt="" />
    </a>
  </nav>
);

export default HeaderActions;
